import { Controller } from "@hotwired/stimulus"
import '../../_jquery';
import 'slick-carousel/slick/slick.min';
import 'waypoints/lib/jquery.waypoints.js';
import { isBackend } from '../../utils';
import MobileDetect from 'mobile-detect';
const md = new MobileDetect(window.navigator.userAgent);
window.md = md

export default class extends Controller {
  static targets = ['slider']

  connect() {
    if (isBackend()) {
      this.#backendInitializer()
    } else {
      this.initialize_slick_carousel(this.sliderTarget)
    }
  }

  disconnect() {
    this.element.querySelector('.pager-dots').replaceChildren()
    if (this.clonedTarget) {
      this.clonedTarget.remove()
    }
  }

  initialize_slick_carousel(slickTargetElement) {
    let parallax_image_movement, parallax_image_speed, parallax_text_movement, parallax_text_speed, slick_speed;
    let $that = $(slickTargetElement);

    new window.Waypoint({
      element: $that,
      offset: '75%',
      handler: function (direction) {
        // Inside this function `this` is the Waypoint instance
        if (!(md.mobile() || md.tablet())) {
          this.destroy();
          return;
        }

        // `heySlide` custom animation is defined into theme's CSS
        $that.css({
          'animation': 'heySlide 1s linear'
        });
        this.destroy();
      }
    });

    slick_speed = $that.data('speed');

    $that.slick({
      adaptiveHeight: false,
      arrows: true,
      prevArrow: '<div class="slick-prev"></div>',
      nextArrow: '<div class="slick-next"></div>',
      dots: $that.find('.component-slide-split').length > 1,
      appendDots: $that.siblings('.pager-dots'),
      fade: $that.data('fade'),
      autoplay: $that.data('autoplay'),
      rows: 0,
      speed: slick_speed,
      draggable: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            draggable: true,
            fade: false
          }
        }
      ]
    });

    // Slick parallax - not used at the moment
    parallax_text_movement = 2000;
    parallax_text_speed = slick_speed * 0.7;
    parallax_image_movement = 2000;
    parallax_image_speed = slick_speed * 0.8;

    if ($that.data('fade') === false) {
      $that.on('beforeChange', function (event, slick, current, next) {
        let current_slide, direction, next_slide;

        current_slide = slick['$slides'][current];
        next_slide = slick['$slides'][next];

        if (current > next) {
          return direction = '+';
        } else {
          return direction = '-';
        }
      });
    }
  }

  #backendInitializer() {
    const cloneAndInsert = () => {
      this.clonedTarget = this.sliderTarget.cloneNode(true)
      this.sliderTarget.style.display = 'none'
      this.clonedTarget.style.display = 'block'
      this.sliderTarget.parentElement.appendChild(this.clonedTarget)
    }

    cloneAndInsert()

    let observer = new window.MutationObserver(function (mutations, observer) {
      this.clonedTarget.remove()
      this.element.querySelector('.pager-dots').replaceChildren()

      cloneAndInsert()

      this.initialize_slick_carousel(this.clonedTarget)
    }.bind(this));
    observer.observe(this.sliderTarget, { subtree: true, attributes: true, childList: true });

    this.initialize_slick_carousel(this.clonedTarget)
  }
}
